import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaChevronDown, FaSearch } from "react-icons/fa";
import StorageService from "../../services/StorageService";
import { buildLoginPath } from "../../utils/authRedirect";

export default function ProcurementServicesHeader() {
  const navigate = useNavigate();
  const [servicesOpen, setServicesOpen] = useState(false);
  const [resourcesOpen, setResourcesOpen] = useState(false);
  const isAuthed = StorageService.isAuthenticated();

  return (
    <header className="ps-header">
      <div className="ps-header__inner">
        <Link to="/home" className="ps-header__brand" aria-label="Trocanet home">
          <span className="ps-header__brand-mark" aria-hidden />
          <span className="ps-header__brand-name">TROCANET</span>
        </Link>

        <nav className="ps-header__nav" aria-label="Primary">
          <div
            className="ps-header__nav-item ps-header__nav-item--dropdown"
            onMouseEnter={() => setServicesOpen(true)}
            onMouseLeave={() => setServicesOpen(false)}
          >
            <button type="button" className="ps-header__nav-link">
              Services <FaChevronDown aria-hidden />
            </button>
            {servicesOpen ? (
              <div className="ps-header__dropdown">
                <Link to="/procurement-services/supplier-discovery">Supplier Discovery</Link>
                <Link to="/procurement-services/managed-procurement">Managed Procurement</Link>
                <Link to="/procurement-services/procurement-retainer">Procurement Retainer</Link>
                <Link to="/logistics-providers">Logistics</Link>
              </div>
            ) : null}
          </div>
          <Link to="/procurement-services#ps-industries" className="ps-header__nav-link">
            Industries
          </Link>
          <div
            className="ps-header__nav-item ps-header__nav-item--dropdown"
            onMouseEnter={() => setResourcesOpen(true)}
            onMouseLeave={() => setResourcesOpen(false)}
          >
            <button type="button" className="ps-header__nav-link">
              Resources <FaChevronDown aria-hidden />
            </button>
            {resourcesOpen ? (
              <div className="ps-header__dropdown">
                <Link to="/help-center">Help Center</Link>
                <Link to="/faq">FAQ</Link>
                <Link to="/blog">Blog</Link>
              </div>
            ) : null}
          </div>
          <Link to="/about" className="ps-header__nav-link">
            About Us
          </Link>
          <Link to="/contact?enquiry=supplier" className="ps-header__nav-link">
            Pricing
          </Link>
        </nav>

        <div className="ps-header__actions">
          <button type="button" className="ps-header__search" aria-label="Search">
            <FaSearch aria-hidden />
          </button>
          {isAuthed ? (
            <Link to="/home" className="ps-header__login">
              Dashboard
            </Link>
          ) : (
            <Link to={buildLoginPath("/procurement-services")} className="ps-header__login">
              Login
            </Link>
          )}
          <button
            type="button"
            className="ps-header__cta"
            onClick={() => navigate("/procurement-services#ps-services")}
          >
            Get Started
          </button>
        </div>
      </div>
    </header>
  );
}
